// PARAMÈTRES DE DEBUG GLOBAUX POUR DES RENDUS REPRODUCTIBLES (R19, audit du
// 15/10/2026 : centre de composition et position de la pochette).
//
// ?coverpos=center|tl|tr|bl|br  force la position de la pochette DOM (le
//     réglage « Position de la pochette », body[data-coin]) quelle que soit la
//     configuration de l'utilisateur.
//
// ?freezetime=<s>  fige le temps. Le module doit être ÉVALUÉ AVANT TOUT AUTRE
//     (premier import du point d'entrée) : il remplace Date, performance.now
//     et Math.random par une horloge virtuelle et un générateur à graine fixe.
//     L'horloge n'avance que quand SceneManager.renderFrozen la fait avancer,
//     par pas de 1/60 s, jusqu'à <s> secondes après la pose du visualiseur ;
//     la boucle requestAnimationFrame ne tourne pas. Deux chargements de la
//     même page rendent donc la même image, au flottant du GPU près, y
//     compris pour les visualiseurs à rétroaction ou à état (Echo, Preset,
//     Flowmap, Lightpaint, Morph), et les entrées musicales simulées (horloge
//     du morceau, phase de temps) sont les mêmes d'une image à l'autre.
//     Les Web Workers gardent leur propre horloge : leurs calculs sont
//     déterministes, il suffit de les laisser finir avant de rendre.

const params = typeof location !== 'undefined' ? new URLSearchParams(location.search) : new URLSearchParams();

const COINS = { center: 'centre', centre: 'centre', tl: 'hg', tr: 'hd', bl: 'bg', br: 'bd' };
// Le code de coin de config-utilisateur.js ('centre' | 'hg' | 'hd' | 'bg' | 'bd'), ou null.
export const COVER_POS_OVERRIDE = COINS[params.get('coverpos')] || null;

const brut = params.get('freezetime');
export const FREEZE_TIME_S = brut != null && brut !== '' && Number.isFinite(Number(brut)) && Number(brut) >= 0 ? Number(brut) : null;

// Pas de l'horloge virtuelle.
export const FREEZE_STEP_S = 1 / 60;

let virtuelMs = 0;

if (FREEZE_TIME_S != null) {
  const DATE0 = Date.UTC(2026, 0, 1, 21, 0, 0);
  const PERF0 = 1000;
  const VraieDate = Date;
  // new Date() sans argument et Date.now() lisent l'horloge virtuelle ; avec
  // des arguments, Date se comporte comme d'habitude.
  class DateFigee extends VraieDate {
    constructor(...a) { if (a.length) super(...a); else super(DATE0 + virtuelMs); }
    static now() { return DATE0 + virtuelMs; }
  }
  globalThis.Date = DateFigee;
  performance.now = () => PERF0 + virtuelMs;
  // mulberry32, graine fixe.
  let graine = 0x2f6b9e17;
  Math.random = () => {
    graine = (graine + 0x6d2b79f5) | 0;
    let t = graine;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function advanceFrozenClock(ms) { virtuelMs += ms; }
